import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import RatingIcon from './rating-icon';
import { Rating } from '../../../components/rating/src/types';
import { getSmileyRating } from './utils';
import * as S from './styles';

type OwnProps = {
  featured: boolean;
  rating: Rating;
  reviewCount?: number | null;
  scoreVisibility?: 'row' | 'compact';
  size?: 'small' | 'normal';
};

const RatingSmiley = ({
  featured,
  rating,
  reviewCount,
  scoreVisibility,
  size = 'normal',
}: OwnProps) => {
  const { t } = useContext(AppContext);
  const iconSize = size === 'small' ? 17 : 21;

  const smileyRating = getSmileyRating(rating.real);

  return smileyRating ? (
    <>
      <S.RatingSmiley>
        {smileyRating.iconType ? (
          <S.IconWrapper
            aria-label={t('reviews', 'rating.rate-n-text-version', {
              n: rating.roundedString,
            })}
            data-rating={rating.roundedString}
            scoreVisibility={scoreVisibility}
            size={size}
          >
            <RatingIcon
              type={smileyRating.iconType}
              disabled={!featured}
              size={iconSize}
            />
          </S.IconWrapper>
        ) : null}
        {reviewCount && (
          <S.RatingCount>
            {`(${reviewCount > 500 ? '500+' : reviewCount})`}
          </S.RatingCount>
        )}
      </S.RatingSmiley>
    </>
  ) : null;
};

export default RatingSmiley;
